import apiClient from './api';

export const paymentService = {
  purchaseTherapyPackage: async (payload) => {
    // Map camelCase client payload to PascalCase keys expected by the current API
    // (production API still expects PascalCase DTO property names).
    const mapped = {
      TherapyPackageId: payload.therapyPackageId || payload.TherapyPackageId,
      BuyerName: payload.buyerName || payload.BuyerName || '',
      BuyerEmail: payload.buyerEmail || payload.BuyerEmail || '',
      BuyerPhone: payload.buyerPhone || payload.BuyerPhone || '',
      BuyerAddress: payload.buyerAddress || payload.BuyerAddress || '',
      Amount: payload.amount || payload.Amount || 0,
      ReturnUrl: payload.returnUrl !== undefined ? payload.returnUrl : (payload.ReturnUrl ?? null),
      CancelUrl: payload.cancelUrl || payload.CancelUrl || null,
      TherapistId: payload.therapistId || payload.TherapistId || null,
      ScheduledFor: payload.scheduledFor || payload.ScheduledFor || null
    };

    console.debug('paymentService.purchaseTherapyPackage payload (mapped):', mapped);

    // For maximum compatibility with different server deployments, include both
    // PascalCase and camelCase keys in the outgoing JSON so either binder will pick them up.
    const fullPayload = {
      // PascalCase (primary)
      ...mapped,
      // Include amount in PascalCase as well
      Amount: mapped.Amount,
      // camelCase duplicates
      therapyPackageId: mapped.TherapyPackageId,
      buyerName: mapped.BuyerName,
      buyerEmail: mapped.BuyerEmail,
      buyerPhone: mapped.BuyerPhone,
      buyerAddress: mapped.BuyerAddress,
      amount: mapped.Amount,
      returnUrl: mapped.ReturnUrl,
      cancelUrl: mapped.CancelUrl
      ,
      therapistId: mapped.TherapistId,
      scheduledFor: mapped.ScheduledFor
    };

    console.debug('paymentService.purchaseTherapyPackage fullPayload (sent):', fullPayload);

    const res = await apiClient.post('/payments/purchase-therapy-package', fullPayload);
    return res.data;
  },

  checkPaymentStatus: async (orderId) => {
    const res = await apiClient.post(`/payments/check-payment-status/${orderId}`);
    return res.data;
  },

  getPayOSPaymentInfo: async (orderCode) => {
    const res = await apiClient.get(`/payments/payos/${orderCode}`);
    return res.data;
  }
  ,
  getOrderIdByPayOS: async (orderCode) => {
    const res = await apiClient.get(`/payments/by-payos/${orderCode}`);
    return res.data;
  }
  ,
  // Development / test helper: ask backend to simulate completing an order and optionally set pending appointment context
  simulateComplete: async (orderId, context = null) => {
    // context should be { TherapistId, ScheduledFor } or null
    const res = await apiClient.post(`/payments/simulate-complete/${orderId}`, context);
    return res.data;
  }
};

export default paymentService;
